import ajax from '@/utils/ajax'

/**
 * @module 营销基金
 */

// 获取营销基金
export const getMaketFund = params => ajax.post('/gasMarketingFund/detailByGasId', params)

// 获取营销基金列表
export const getMaketFundList = params => ajax.post('/gasMarketingFund/getGasMarketingFundLog', params)

// 获取当前账号油站开户状态
export const getAccountType = params => ajax.post('/gasMarketingFund/openAccountList', params)

// 操作类型枚举接口
export const getOperatorTypeEnums = params => ajax.post('gasMarketingFund/getOperatorTypeEnums', params)

// 获取最大的消息提示阈值
export const maxNoticeAmount = params => ajax.post('notice/maxNoticeAmount', params)

// 添加消息已读次数
export const addTimes = params => ajax.post('notice/addTimes', params)

// 查询用户下油站存在余额不足的消息
export const getNoticeList = params => ajax.post('notice/noticeList', params)

//营销基金  导出
export const downloadMarketOptimizationListApi = params => ajax.post('gasMarketingFund/exportMarketingFundLog', params)